import { GameConfigs, GameDetail } from "./GameConfig"
export interface TournamentsConfig {
  success: boolean
  nextToken?: number
  noResultText?: string | null
  dailyLimitExceeded?: boolean
  lifetimeLimitExceeded?: boolean
  limitDescription?: string | null
  isBlocking?: boolean
  message?: string | null
  widgets?: Widget[]
  data?: TournamentData;
  downloadScreenData?: DownloadScreenDataConfig;
  helpScreenData?: HelpScreenDataConfig;
  errorType?: string | null;
  externalMessage?: string | null;
}
export interface TournamentData {
  lobby: Lobby;
  homeScreenData: HomeScreenData;
  gameDetails: GameDetail[];
  downloadScreenData: DownloadScreenDataConfig;
  helpScreenData: HelpScreenDataConfig;
}

export interface HomeScreenConfig {
  downloadScreenData: DownloadScreenDataConfig;
  helpScreenData: HelpScreenDataConfig;
}

export interface HelpScreenDataConfig {
  banner: {
    imageUrl: string
    cta: Cta;
  };
}
export interface DownloadScreenDataConfig {
  banner: {
    imageUrl: string
    bannerText?: string;
    cta: Cta;
  };
}
interface Lobby {
  tournamentsList: TournamentsList;
  gameConfigs: GameConfigs;
}
interface TournamentsList {
  widgets?: Widget[];
}


export interface Widget {
  items: WidgetItem[]
  style?: WidgetStyle
  header?: string
  widgetType?: string
  isHeader?: boolean
  appendBelow?: boolean
  allTable?: boolean
  sortOption?: SortOption
  modificationRequired?: boolean
  isCollapsable?: boolean
  recentlyConcludedTable?: boolean
  displayPriority?: number | null
  _id?: string
  pwaBanner?: pwaBannerTypes;
  onClick?: () => void;
  widgetIndex?: number;
  firstMegaTournamentIndex?: number;
  firstMahaMegaTournamentIndex?: number;
}

export interface WidgetItem {
  gameFormatImage?: string;
  header?: string
  filledCta?: FilledCta
  _id?: string
  isGold?: boolean
  entryFee?: number
  maxParticipants?: number
  name?: string
  description?: string
  tournamentType?: string
  userLevelsSupported?: number[]
  winnerType?: string
  stt?: number
  tournamentId?: number
  bonusPercentageUsageOnStandaloneApp?: number
  bonusPercentageUsageOnSuperApp?: number
  prizeDistribution?: Record<string, Record<string, number>>;
  minParticipants?: number
  minSlotCutOffTime?: number
  maxPlayingAttempt?: number
  maxWinners?: number
  totalPrizePot?: number
  resultDeclareTime?: number
  endTime?: number
  displayEndTime?: number
  tag?: string
  registrationEndTime?: number
  playingAttempt?: number
  displayImage?: string
  widgetIdV2?: string
  scheduleDynamically?: boolean
  rakebackPoints?: number | null
  startTime?: number
  numRegistrations?: number
  isHidden?: boolean
  zupeeGameType?: string
  registrationStartTime?: number
  displayStartTime?: number
  timeLimitInSecs?: number
  widgetType?: string | null
  merchant?: string
  isMegaTournament?: boolean
  displayPriority?: any //TODO Need to find the type for it
  creditType?: string
  gameFormatType?: string
  prizePot?: PrizePot
  distribution?: Distribution
  maxNumberOfPlayers?: number
  maxNumberOfWinners?: MaxNumberOfWinners
  minNumberOfPlayers?: number
  poolDistribution?: PoolDistribution[]
  ltid?: number
  tournamentStatus?: string
  isSuspended?: boolean
  expiredAt?: string
  isInstantEntryFeeCreditEnabled?: boolean
  tournamentJobStatus?: string
  showTimer?: boolean
  generalInfo?: GeneralInfo
  nameV2?: NameV2
  widgetId?: string
  imageUrl?: string
  cta?: Cta
  matchDetails?: MatchDetails,
  tournamentStartTimeText?: string
  tournamentEndTimeText?: string
  tournamentResultOutTimeText?: string
  isLocked?: boolean
  isReferralNxTournament?: boolean
  displayTag?: string
  pointers?: GameRules;
  enableRegistration?: boolean;
  skipTournamentDetailsPage?: boolean;
  gameplayServer?: GameplayServer;
  poolDistributionInfo?: PoolDistributionInfo,
}

export interface GameplayServer {
  host: string;
  port: string;
  proto: string;
  serverId: string;
  gameName: string;
  ng_idx: number;
  ng_ipx: string;
}


export interface MatchDetails {
  matchType?: string
  team1?: string
  seriesName?: string
  team2?: string
  icon?: string
  suspendedIcon?: string
  iconBlack?: string
}

export interface FilledCta {
  displayText?: string
  type?: string
  value?: string
}

export interface PrizeDistribution {
  "6"?: N6
  "13"?: N13
  "94"?: N94
}

export interface N6 {
  "1": number
  "2": number
  "3": number
  "4": number
  "6": number
}

export interface N13 {
  "1": number
  "2": number
  "4": number
  "5": number
  "6": number
  "13": number
}

export interface N94 {
  "1": number
  "2": number
  "3": number
  "18": number
  "94": number
}

export interface PrizePot {
  "1": number
}

export interface Distribution {
  "1": N1
}

export interface N1 {
  "1": number
}

export interface MaxNumberOfWinners {
  "1": number
}

export interface PoolDistribution {
  label: string
  amt: string
}

export interface PoolDistributionInfo {
  id: string,
  text: string,
  defaultViewLimit: number,
  distribution: {
    label: string,
    amt: string
  }[]
}

export interface GeneralInfo {
  firstPrizeText?: string
  prizePoolText?: string
  entryFeeText?: string
  assuredWinnersText?: string
  isInstantEntryFeeCreditEnabled?: boolean,
  instantWinningsMinScoreTitle?: string,
  instantRefundTitle?: string
}

export interface NameV2 {
  prefix?: string
  sufix?: string
  completeName?: string
  totalPlayers?: number
  totalwinners?: number
}

export interface Cta {
  type?: string
  value?: string
}

export interface WidgetStyle {
  titleHex?: string
  bgPrimaryDark?: string
  bgPrimary?: string
  bgStroke?: string
  header?: string
  labels?: string
  prizeDistribution?: string
  entryFee?: EntryFee
  prizePool?: PrizePool
  timer?: Timer
  desclaimer?: string
  tnc?: string
  quick?: string
}

export interface EntryFee {
  default?: Default
  registered?: Registered
  free?: Free
}

export interface Default {
  bg: string
  border: string
  title: string
}

export interface Registered {
  bg: string
  border: string
  title: string
}

export interface Free {
  bg: string
  border: string
  title: string
}

export interface PrizePool {
  bg?: string
  border?: string
  title?: string
}

export interface Timer {
  "10": string
  "15": string
  "-1": string
}

export interface SortOption {
  table?: string
  sortOn?: string
  order?: string
}


//Game Details Types
interface Game {
  gameName?: string;
  title?: string;
  packageName?: string;
  description?: string;
  versionCode?: number;
  isForceUpdate?: boolean;
  apkUrlArmV7?: string;
  apkUrlArmV8?: string;
  logoUrl?: string;
  downloadInBackgroundDelay?: number;
  subAppDownloadTrigger?: string;
  coverImage?: string;
  coverImageV2?: string;
  downloadTrigger?: string[];
}

export interface GamesResponse {
  success: boolean;
  games: Game[];
}

interface HomeScreenData {
  showWallet: boolean;
}

export interface pwaBannerTypes {
  imageUrl: string;
  cta: Cta;
  bannerText?: string;
}

interface ExpandedItem {
  text: string;
  infoText?: string;
}

interface Item {
  id: string;
  text: string;
  description?: string;
  defaultExpanded?: boolean;
  tag?: {
    enable: boolean;
    text: string;
  };
  expandedItems: ExpandedItem[];
}

export interface GameRules {
  id: string;
  text: string;
  items: Item[];
}

export enum TournamentStatus {
  TOURNAMENT_NOT_STARTED = 'TOURNAMENT_NOT_STARTED',
  TOURNAMENT_LIVE_USER_NOT_ENTERED = 'TOURNAMENT_LIVE_USER_NOT_ENTERED',
  TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING = 'TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING',
  TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING = 'TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING',
  TOURNAMENT_CLOSED_RESULT_PENDING = 'TOURNAMENT_CLOSED_RESULT_PENDING',
  TOURNAMENT_CLOSED_RESULT_OUT = 'TOURNAMENT_CLOSED_RESULT_OUT',
  TOURNAMENT_CLOSED_DISPLAY_ENDED = 'TOURNAMENT_CLOSED_DISPLAY_ENDED'
}
